var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTree3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(-96,-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4-9-0",
    transform: "translate(0,64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-50-2-9-9-0",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 101.27456,20.730069 c 0.18868,0.188679 3.63271,-0.443079 4.52831,-1.886792 0.3653,-0.588883 0.1895,-1.552919 -0.25354,-2.121173 l -0.68986,0.68986 v 1.431312 c 0,0.10421 -0.0845,0.188678 -0.1887,0.188678 -0.10422,0 -0.18868,-0.08449 -0.18868,-0.188678 v -1.053954 l -0.7547,0.754716 v 0.67512 c 0,0.10421 -0.0845,0.18868 -0.1887,0.18868 -0.10422,0 -0.18868,-0.08446 -0.18868,-0.18868 v -0.297757 l -0.80999,0.809993 c -0.0737,0.07366 -0.19313,0.07366 -0.26681,0 -0.0737,-0.07368 -0.0737,-0.19312 0,-0.266802 l 0.81,-0.809995 h -0.30181 -0.002 c -0.24805,-0.0037 -0.24805,-0.373854 0,-0.377363 h 0.002 0.67917 l 0.75474,-0.754714 h -1.05396 c -0.10422,0 -0.18868,-0.08449 -0.18868,-0.18868 0,-0.10421 0.0845,-0.188679 0.18868,-0.188679 h 1.43132 l 0.69087,-0.690872 c -0.57017,-0.45238 -1.52127,-0.622035 -2.12218,-0.252526 -1.44088,0.88601 -2.07548,4.339626 -1.8868,4.528306 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-5-0-1-0-2-82-9-0-4-0",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 117.27456,22.730069 c 0.18868,0.188679 3.63271,-0.443079 4.52831,-1.886793 0.3653,-0.588883 0.1895,-1.552919 -0.25354,-2.121172 l -0.68986,0.68986 v 1.431312 c 0,0.10421 -0.0845,0.188678 -0.1887,0.188678 -0.10422,0 -0.18868,-0.08449 -0.18868,-0.188678 v -1.053954 l -0.7547,0.754716 v 0.67512 c 0,0.10421 -0.0845,0.18868 -0.1887,0.18868 -0.10422,0 -0.18868,-0.08446 -0.18868,-0.18868 v -0.297757 l -0.80999,0.809993 c -0.0737,0.07366 -0.19313,0.07366 -0.26681,0 -0.0737,-0.07368 -0.0737,-0.19312 0,-0.266802 l 0.81,-0.809995 h -0.30181 -0.002 c -0.24805,-0.0037 -0.24805,-0.373854 0,-0.377363 h 0.002 0.67917 l 0.75474,-0.754714 h -1.05396 c -0.10422,0 -0.18869,-0.08449 -0.18869,-0.18868 0,-0.10421 0.0845,-0.188679 0.18869,-0.188679 h 1.43132 l 0.69087,-0.690872 c -0.57017,-0.45238 -1.52127,-0.622035 -2.12218,-0.252526 -1.44088,0.88601 -2.07548,4.339626 -1.8868,4.528306 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-5-0-1-0-2-8-3-9-1-9-3",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 126.72544,18.73007 c -0.18868,0.188679 -3.63271,-0.443079 -4.52831,-1.886793 -0.3653,-0.588883 -0.1895,-1.552919 0.25354,-2.121172 l 0.68986,0.68986 v 1.431312 c 0,0.104209 0.0845,0.188677 0.1887,0.188677 0.10422,0 0.18868,-0.08449 0.18868,-0.188677 v -1.053955 l 0.7547,0.754716 v 0.67512 c 0,0.10421 0.0845,0.18868 0.1887,0.18868 0.10422,0 0.18868,-0.08446 0.18868,-0.18868 v -0.297757 l 0.80999,0.809993 c 0.0737,0.07366 0.19313,0.07366 0.26681,0 0.0737,-0.07368 0.0737,-0.19312 0,-0.266802 l -0.81,-0.809995 h 0.30181 0.002 c 0.24805,-0.0037 0.24805,-0.373854 0,-0.377363 h -0.002 -0.67917 l -0.75474,-0.754714 h 1.05396 c 0.10422,0 0.18869,-0.08449 0.18869,-0.18868 0,-0.10421 -0.0845,-0.188679 -0.18869,-0.188679 h -1.43132 l -0.69087,-0.690872 c 0.57017,-0.45238 1.52127,-0.622035 2.12218,-0.252526 1.44088,0.88601 2.07548,4.339626 1.8868,4.528307 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9-0-6-3-5-2",
    style: {
      color: "#000000",
      fill: "#a5a664",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 108,13.5 c -0.21776,0.0902 -0.40749,0.28321 -0.5,0.5 -0.19219,0.450404 0.31506,1.122481 -0.0312,1.468754 -0.34627,0.346284 -1.01839,-0.160956 -1.4688,0.03125 -0.21679,0.09251 -0.5,0.264298 -0.5,0.5 0,0.235702 0.28224,0.409801 0.5,0.5 0.44495,0.184303 1.02097,-0.228685 1.44482,0 C 108.37152,17 110.50095,19 110.75,20 c 0.64445,2.587624 -1.02049,5.536321 0,8 0.2255,0.544401 0.66074,1.25 1.25,1.25 0.58926,0 1.0245,-0.705599 1.25,-1.25 0.99956,-2.413154 -0.99956,-5.422784 0,-7.835938 0.61589,-1.486895 1.92716,-2.79817 3.41406,-3.414062 1.02734,-0.425536 2.30581,-0.418731 3.33594,0 0.70971,0.288487 0.9368,1.315024 1.64651,1.603511 0.21833,0.08875 0.54039,0.166651 0.70704,0 0.16665,-0.166649 0.0888,-0.488709 0,-0.707032 -0.28857,-0.709772 -1.60392,-0.88029 -1.60391,-1.64648 1e-5,-0.766206 1.3154,-0.936696 1.60398,-1.64648 0.0888,-0.218322 0.13093,-0.511071 0,-0.707032 C 122.28274,13.540401 122.12759,13.499994 122,13.5 c -0.12756,6e-6 -0.24747,0.07561 -0.35352,0.146484 -0.62906,0.420381 -0.90144,1.32666 -1.60498,1.604981 -1.09829,0.434481 -2.7198,0.7351 -3.5415,-0.113316 -0.26394,-0.27252 0.14518,-0.787645 0,-1.138149 -0.0902,-0.21776 -0.2643,-0.5 -0.5,-0.5 -0.2357,0 -0.4098,0.28224 -0.5,0.5 -0.14519,0.350515 0.14644,0.788191 0,1.138184 -0.66409,1.587177 -1.95528,3.62875 -3.67578,3.623535 -1.56531,-0.0047 -2.72436,-1.871064 -3.32417,-3.316899 -0.18455,-0.444846 0.1843,-0.999873 0,-1.44482 -0.0902,-0.21776 -0.28224,-0.409801 -0.5,-0.5 -2e-5,-6e-6 -3e-5,-6e-6 -5e-5,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#7d451b",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 108,26 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 8 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z",
    id: "path1-04-9-9-2-1-8"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter"
    },
    id: "rect24-7-3-2",
    width: 32,
    height: 32,
    x: 96,
    y: 0,
    rx: 0,
    ry: 2.7755576e-17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTree3);
export default __webpack_public_path__ + "static/media/icon_tree3.0398e818a01c9e865ec947bb09038167.svg";
export { ForwardRef as ReactComponent };